import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-validator"
export default class extends Controller {
  static targets = ["input", "submit"]
  connect() {
    this.validate()
  }

  validate() {
    const filled = this.inputTargets.every(el => {
      return el.value && el.value.trim() !== ""
    })

    this.submitTarget.disabled = !filled
  }
}
